import jwtDecode from 'jwt-decode';
import { AuthUser } from './constants';
import { logError } from '../ErrorTracking';

const decodeToken = (token: string): AuthUser | null => {
  try {
    const decoded = jwtDecode<AuthUser>(token);
    decoded.token = token;
    return decoded;
  } catch (error) {
    logError(error);
    return null;
  }
};

export default decodeToken;
